import React from 'react';

const Faq = () => {
  return <div>FAQ</div>;
};

export default Faq;
